import type { Components, Theme } from '@mui/material/styles'

export const MuiMenuOverride: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    list: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
}
